import { useContext } from "react";
import { ScannerContext } from "./scanner-context";

export function useScannerContext() {
  const ctx = useContext(ScannerContext);
  if (!ctx) throw new Error("useScannerContext must be used within ScannerProvider");
  return ctx;
}
